import React,{createContext, useState} from 'react';

import axios from 'axios';

import Utils from './../Utils';

import _ from 'lodash';

const UserContext = createContext();

const UserProvider = (props) => {

  const [userData, setUserData] = useState(Utils.getUserData());
  const [thirdPUserData, setThirdPUserData] = useState(false);
  const [stepData, setUCStepData] = useState({});
  const [pkgInfo, setPkgInfo] = useState({category : '', size : 0, cloud : false, duedt : null, id : 0});
  const [pkgValidity, setPkgValidity] = useState({validity : false, msg : ''});

  const getPkgSize = () => {
    const slides =  _.get(stepData,'slides', []);      
    var size = 0;
    if(_.isArray(slides)){
      size = _.sum(slides.map(s => {
          if((s.type !== 'Template')){
            if(s.type === 'Photo'){      
              if(!(_.isUndefined(s.size))){
                return parseFloat(_.get(s,'size.photo',s.size)) + parseFloat(_.get(s,'size.audio',s.size)); 
              }else{
                return parseFloat(s.data.size.photo) + parseFloat(s.data.size.audio);
              } 
            }else{
              return parseFloat(s.data.size);
            }
          }else{
            return 0;// For Template.
          }
        }
      ));
    }
    return size;
  }

  const getMaxScormSize = () => {
    let scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
    return _.max([_.get(userData,'scorm_size',50),scormsize_in_mb]);
  };

  const getAvailableSize = (minSize) => {
    const scormsize_in_mb = getMaxScormSize();
    if(_.min([minSize,scormsize_in_mb - getPkgSize()])!== undefined){
     return Number(_.min([minSize,scormsize_in_mb - getPkgSize()])).toFixed(1);
    }
    //return _.min([minSize,scormsize_in_mb - getPkgSize()]).to;
  }
  const [pkgSize,setPkgSize] = useState();

  const goLogin = ({username, password},callback) => {  
    axios.post(Utils.apiUrl('auth/login'),`&username=${username}&password=${password}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message, res.data.flag);      
      if(res.data.success){        
        setUserData(res.data.data);   
        Utils.setUserData(res.data);             
      }
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const thirdPartyLogin = (username, callback) => {
    axios.post(Utils.apiUrl('auth/thirdLogin'),`&username=${username}`, Utils.apiHeaders())
        .then(res => {
          callback(res.data.success, res.data.message);
          if(res.data.success){
            setUserData(res.data.data);
            Utils.setUserData(res.data);
          }
        })
        .catch(err => {
          callback(false, err.message);
        });
    
  }

  const getThirdPartyData = (token,functionName,callback) => {

    axios.post(Utils.apiUrl('auth/checkAndGetThirdPartyData'),`&token=${token}&functionName=${functionName}`, Utils.apiHeaders())
        .then(res => {
          callback(res.data);
          if(res.data.success){
            setThirdPUserData(res.data);
          }
        })
        .catch(err => {
          callback(false,err.message);
        });
    
  }
  const goFrgpwd = ({username, password},callback) => {    
    axios.post(Utils.apiUrl('auth/frgpwd'),`&username=${username}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message, res.data.flag);      
    }).catch(err => {
      callback(false, err.message);
    });
  }



  const goActivate = ({code},callback) => {    
    axios.post(Utils.apiUrl('auth/activate'),`&code=${code}`,Utils.apiHeaders()).then(res => {    
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const changePassword = (data,callback) => {    
    axios.post(Utils.apiUrl('auth/changepwd'),data,Utils.apiHeaders()).then(res => {
      // if(res.data.success === false){
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return;
      // }    
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const goRegistration = ({name, username, password, picture, source, buyer},callback) => {    
    axios.post(Utils.apiUrl('auth/register'),`&name=${name}&username=${username}&password=${password}&picture=${picture}&source=${source}&buyer=${buyer}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message,res.data.flag);
      if(res.data.success){
        setUserData(res.data.data);         
        res.data.data = {...res.data.data, selpkg:selectedPackage()};        
        Utils.setUserData(res.data);
      }
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const saveProfile = (data,callback) => {
    axios.post(Utils.apiUrl('auth/saveprofile'),data,Utils.apiHeaders()).then(res => {  
      // if(res.data.success === false){
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return;
      // }    
      if(res.data.success){
        setUserData(res.data.data);
        Utils.setUserData(res.data);
      }
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const logout = (callback) => {
    setUserData(false);
    Utils.setUserData(false); 
       
    callback();
  }

  const loadPackage = () => {
    return new Promise((resolve,reject) => {
        axios.get('/svasu/pkgs.json')
        .then((res) =>{
          Utils.addToUserData({pkgArr:res.data.packages});
          resolve(res.data.packages);          
      }).catch(reject);
    });    
  }

  const getPackage = () => {
    return _.get(Utils.getUserData(),'pkg', false);
  }

  const setPackage = (pkg) => {
    if(typeof pkg === 'string') Utils.addToUserData({selpkg: pkg});
    else if (typeof pkg === 'object') Utils.addToUserData({selpkg : pkg.id, cloud : pkg.cloud});
  }

  const selectedPackage = () => {
    return _.get(Utils.getUserData(),'selpkg', false);
  }

  const checkPkgValidity = (callback) => {

    axios.get(Utils.apiUrl('Package/checkUserPkgValidity'), Utils.apiHeaders())
      .then(res => { callback(res.data); })
      .catch(err => console.log("Package Validity Error : " , err));
    
  }
  
  const saveDraft = (rsc, callback) => {
    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';
    const stepData = Utils.getStepData();
    axios.post(Utils.apiUrl('Draft/savedraft'), { scorm: _.omit(stepData, 'slides', 'step'), slides: stepData.slides }, headers)
      .then(res => {
        if (res.data.success) {
          callback(res.data.success, res.data.message);        
          let udata = Utils.getUserData();
          udata = {...udata, draft:res.data.draft_id};
          udata[`stepData${udata.id}`] = {step : 1};
          localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(udata));          
        } else {
          console.log(res)
            window.alert('Some error occurred on server!');
        }
      }).catch(err => {
        window.alert(JSON.stringify(err));
      });
  }


  const loadDraft = () => {
    axios.get(Utils.apiUrl(`Draft/loadDraft?uid=${userData.id}`), Utils.apiHeaders())
      .then(res => {
        const udata = Utils.getUserData();
        const stepData1 = `stepData${udata.id}`;         
          if(res.data.success){
            const d = JSON.parse(res.data.data);                
            const editData = {
              ...d.scorm,
              step      : 3,
              slides    : d.slides,
              folder    : d.folder,
            };
            udata['draft'] = 'edit';                
            Utils.setUserData({...udata, stepData1 : editData});
            Utils.saveUserData(udata, editData);              
            window.location.href = process.env.PUBLIC_URL;
          }else{
            udata['draft'] = false;
            Utils.setUserData({...udata, stepData1 : {step : 1}});
            Utils.saveUserData(udata, {step : 1}); 
            window.alert(res.data.error);
            window.location.href = process.env.PUBLIC_URL + '/builder';
          }           
        }
      )
      .catch(err =>  window.alert(JSON.stringify(err)));
  }

  const deleteDraft = (callback) => {
    axios.delete(Utils.apiUrl(`Draft/deletedraft`), Utils.apiHeaders())
        .then(res => {          
          callback(res.data.success, res.data.message);
          if(res.data.success){            
            let uData = Utils.getUserData();
            uData = {...uData, draft:false};
            uData[`stepData${uData.id}`] = {step : 1};            
            localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(uData));
          }
        })
        .catch(err => {
          
          window.alert("Draft delete error : ", err);
        })
  }
  
  return <UserContext.Provider value={{ userData, pkgInfo, thirdPUserData, setPkgInfo, getAvailableSize, setUCStepData, getPkgSize, saveProfile, goLogin, goActivate, goFrgpwd, goRegistration, logout, changePassword, 
    setPackage, selectedPackage, getPackage, loadPackage, thirdPartyLogin,loadDraft, deleteDraft, saveDraft, getMaxScormSize, 
    checkPkgValidity,getThirdPartyData }}>
    {props.children}
  </UserContext.Provider>;

}

export default UserContext;

export {UserProvider};